import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import { Component } from '@angular/core';
import links from './links.json';
import { ApiAuthService } from '@app/api';

@Component({
  selector: 'app-layout-secure-side',
  templateUrl: './side.component.html',
  styleUrls: ['./side.component.scss'],
  animations: [
    trigger('toggleSubMenu', [
      state('true', style({ height: '*' })),
      state('false', style({ overflow: 'hidden', height: '0px' })),
      transition('true <=> false', animate('0.3s ease-out')),
    ]),
  ],
})
export class AppLayoutSecureSideComponent {
  public openedLink: any = null;
  public openedChildLink: any = null;
  public activeLinks: any = [];
  public links: any = links;

  constructor(private _apiAuth: ApiAuthService) {
    this.activeLinks = this.links
      .filter((link: any) => {
        return (
          !link.permissions || this._apiAuth.hasPermissions(link.permissions)
        );
      })
      .map((link: any) => {
        link.children = link.children
          ? [
              ...link.children.filter(
                (child: any) =>
                  !child.permissions ||
                  this._apiAuth.hasPermissions(child.permissions),
              ),
            ]
          : undefined;
        return link;
      });
  }

  toggleLink(link: any, event: Event) {
    event.stopPropagation();
    event.preventDefault();

    if (this.isOpenedLink(link)) {
      this.openedLink = null;
      this.openedChildLink = null;
    } else {
      if (link !== this.openedLink) {
        this.openedChildLink = null;
      }
      this.openedLink = link;
    }
  }

  toggleChildLink(link: any, event: Event) {
    event.stopPropagation();
    event.preventDefault();

    if (this.isOpenedChildLink(link)) {
      this.openedChildLink = null;
    } else {
      this.openedChildLink = link;
    }
  }

  isOpenedLink(link: any) {
    return this.openedLink === link;
  }

  isOpenedChildLink(link: any) {
    return this.openedChildLink === link;
  }
}
